<!-- case form dialog -->
<kendo-dialog [width]="700" (close)="close()" *ngIf="caseForm !== undefined">
    <kendo-dialog-titlebar>
        <h3 class="ellipsis-text">{{'ENROLL-A-MEMBER-TO' | translate:patientLabel}} {{channelToEnroll?.name}}</h3>
    </kendo-dialog-titlebar>
    <form [formGroup]="caseForm" class="k-form" (ngSubmit)="createCase()">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                {{'ENROLLMENT-REASON' | translate}} *
            </span>
            <input id="enrollmentReason" kendoTextBox formControlName="enrollmentReason" maxlength="256" />
            <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="caseForm.controls['enrollmentReason'].invalid && caseForm.controls['enrollmentReason'].touched">
                {{'REQUIRED-ENROLLMENT-REASON' | translate}}
            </div>
        </label>
        <label class="k-form-field mt-3">
            <span class="k-text-uppercase dark">
                {{'ASSIGN-CASE-MANAGER' | translate}} <span
                    *ngIf="channelToEnroll !== undefined && channelToEnroll.caseManagerAssignmentMode === null">*</span>
            </span>
            <kendo-combobox [filterable]="true" (filterChange)="handleCaseManagerFilter($event)"
                (close)="searchTerms=''" class="w-75" formControlName="manager" [data]="caseManagersFiltered"
                [placeholder]="'TYPE-OR-SELECT' | translate" [textField]="'name'" [valueField]="'id'"
                [itemDisabled]="itemDisabled">
                <ng-template kendoComboBoxItemTemplate let-dataItem>
                    <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                    </span>
                </ng-template>
            </kendo-combobox>
            <div class="k-tooltip k-tooltip-validation" role="alert"
                *ngIf="caseForm.controls['manager'].invalid && caseForm.controls['manager'].touched">
                {{'REQUIRED-MANAGER' | translate}}
            </div>
        </label>
    </form>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="caseForm.controls['manager'].setValue(null); close();">
            {{ 'CANCEL' | translate}}
        </button>
        <button appPreventClick kendoButton type="button" [disabled]="caseForm.invalid || creatingCase"
            (click)="createCase()">
            {{ 'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>